package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input

@Composable
fun <T> FilterCheckGroup(
    title: String,
    items: List<T>,
    checkedItems: List<T>,
    onCheckedChange: (T, Boolean) -> Unit,
    label: (T) -> String, // pour afficher
    breakpoint: Breakpoint
) {

    val isMobile = breakpoint < Breakpoint.MD

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = 10.px)
    ) {

        // 🔹 TITRE
        SpanText(
            title,
            modifier = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 10.px)
        )

        // 🔹 BOX
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .border(1.px, LineStyle.Solid, Colors.LightGray)
                .borderRadius(10.px)
                .padding(15.px)
        ) {

            // 🔹 GRID (2 colonnes desktop, 1 mobile)
            items.chunked(if (isMobile) 1 else 2).forEach { rowItems ->

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 10.px),
                ) {

                    rowItems.forEach { item ->
                        val isChecked = checkedItems.contains(item)

                        Row(
                            modifier = Modifier
                                .flexGrow(1),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            // CHECKBOX
                            Input(
                                type = InputType.Checkbox,
                                attrs = Modifier
                                    .margin(right = 10.px)
                                    .cursor(Cursor.Pointer)
                                    .toAttrs {
                                        checked(isChecked)
                                        onChange {
                                            onCheckedChange(item, !isChecked)
                                        }
                                    }
                            )

                            // LABEL
                            SpanText(
                                label(item),
                                modifier = Modifier
                                    .margin(left = 10.px)
                                    .fontSize(14.px)
                            )
                        }
                    }

                    // Remplissage si nombre impair
                    if (rowItems.size == 1 && !isMobile) {
                        Box(modifier = Modifier.flexGrow(1))
                    }
                }
            }
        }
    }
}